import { Controller, FieldValues } from "react-hook-form"
import { IFormControl } from "src/types/index"
import { ISelectorProps, Selector } from "."

type FormSelectProps<T = string, Meta extends object = object, F extends FieldValues = FieldValues> = ISelectorProps<T, Meta> &
  IFormControl<F>
export const FormSelect = <T extends string | number = string, Meta extends object = object, F extends FieldValues = FieldValues>(
  props: FormSelectProps<T, Meta, F>,
) => {
  const { control, name, rules, required, ...rest } = props
  return (
    <Controller
      {...{ control, name, rules: { required: { value: required ?? false, message: "This field is required" }, ...rules } }}
      render={({ field: { value, onChange } }) => <Selector {...rest} value={value} onChange={onChange} />}
    />
  )
}
